import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem("eps_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  const s = localStorage.getItem("eps_site");
  if (s && !c.headers["X-Site-Id"]) c.headers["X-Site-Id"] = s;
  return c;
});

export function fmtErr(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return detail.msg || String(detail);
}

export const fileUrl = (path) => `${BACKEND}/api/files/${path}?auth=${localStorage.getItem("eps_token") || ""}`;

export async function downloadReport(kind) {
  const res = await api.get(kind === "group" ? "/group-report" : `/reports/${kind}`, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${kind}_report.pdf`;
  a.click();
  URL.revokeObjectURL(url);
}

export const ROLE_LABELS = {
  admin: "Admin", operator: "Operator", supervisor: "Supervisor", maintenance_manager: "Maintenance Manager",
  hs_manager: "H&S Manager", site_manager: "Site Manager", contractor: "Contractor", auditor: "Auditor",
};
export const MANAGERS = ["admin", "supervisor", "maintenance_manager", "hs_manager", "site_manager"];
export const APPROVERS = ["admin", "hs_manager", "site_manager"];
export const MODULE_PATHS = { fire: "/fire", coshh: "/coshh", puwer: "/puwer", welfare: "/welfare", maintenance: "/maintenance", first_aid: "/first-aid", ladders: "/ladders", incidents: "/incidents", legionella: "/legionella", audit: "/audits", asrs: "/asrs", training: "/training" };
export const fmtDate = (v) => (v ? new Date(v).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "-");
export const fmtDateTime = (v) => (v ? new Date(v).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "-");
